var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-skill"
  }, [_c("a-row", {
    attrs: {
      gutter: [114, 30]
    }
  }, _vm._l(_vm.skillList, function (item, index) {
    return _c("a-col", {
      key: index,
      attrs: {
        span: _vm.span
      }
    }, [_c("skill-card", {
      attrs: {
        img: item.img,
        title: item.title,
        desc: item.desc,
        cardStyle: _vm.cardStyle,
        lineClamp: _vm.lineClamp
      }
    })], 1);
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };